import type { ReactNode } from "react";
import { cn } from "@repo/ui/lib/utils";

export default function TwoCol({
  left,
  right,
  reverse = false,
  className,
}: {
  left: ReactNode;
  right: ReactNode;
  reverse?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "grid items-center gap-8 md:gap-10 lg:gap-14",
        "md:grid-cols-2",
        reverse && "md:[&>*:first-child]:order-2 md:[&>*:last-child]:order-1",
        className
      )}
    >
      <div>{left}</div>
      <div>{right}</div>
    </div>
  );
}

